define("shared/utils/constants/errors", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DEFAULT_EXEX_ERROR_NAME = _exports.DEFAULT_EXEX_ERROR_MESSAGE = _exports.DEFAULT_EXEX_ERROR_CODE = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const DEFAULT_EXEX_ERROR_CODE = _exports.DEFAULT_EXEX_ERROR_CODE = 0;
  const DEFAULT_EXEX_ERROR_NAME = _exports.DEFAULT_EXEX_ERROR_NAME = 'EmberExexError';
  const DEFAULT_EXEX_ERROR_MESSAGE = _exports.DEFAULT_EXEX_ERROR_MESSAGE = 'An exception has occurred';
});